import { getSiteDisplay } from '@aloft/toolkit-shared';

import { selectSiteById } from '../../../../redux/features/selectors/propertyDataSelectors/siteSelectors.ts';
import { selectSiteCostPerSfDisplay } from '../../../../redux/features/selectors/selectSiteCostPerSf.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { DetailLine } from '../../ColumnComponents/DetailLine.tsx';

type SiteDetailProps = {
  id: string;
};

export const SiteDetails = ({ id }: SiteDetailProps) => {
  const site = useAppSelector((state) => selectSiteById(state, id));
  const siteCostPerSf = useAppSelector((state) => selectSiteCostPerSfDisplay(state, id));

  const { area, costPerSf, influence, notes, view } = getSiteDisplay(site, siteCostPerSf);

  return (
    <>
      <DetailLine text={`${area} (${costPerSf})`} />
      <DetailLine text={`${influence} | ${view}`} />
      <DetailLine text={notes} />
    </>
  );
};
